<template>
    <div>
        <div class="indexcon">
            <banner :banner="bannerList"></banner>
        </div>
        <div class="filter-wrap">
            <!-- 城市下拉 -->
            <el-select v-model="searchForm.city" placeholder="北京" clearable size="small">
                <el-option label="北京" value="beijing"></el-option>
                <el-option label="上海" value="shanghai"></el-option>
                <el-option label="广州" value="guangzhou"></el-option>
            </el-select>

            <!-- 学历下拉 -->
            <el-select v-model="searchForm.education" placeholder="学历" clearable size="small">
                <el-option label="大专" value="college"></el-option>
                <el-option label="本科" value="bachelor"></el-option>
                <el-option label="硕士" value="master"></el-option>
            </el-select>

            <!-- 薪资下拉 -->
            <el-select v-model="searchForm.salary" placeholder="薪资" clearable size="small">
                <el-option label="5k以下" value="0-5"></el-option>
                <el-option label="5k-10k" value="5-10"></el-option>
                <el-option label="10k-20k" value="10-20"></el-option>
                <el-option label="20k以上" value="20+"></el-option>
            </el-select>

            <!-- 岗位下拉（支持搜索 filterable） -->
            <el-select v-model="searchForm.job" placeholder="岗位" filterable clearable size="small"
                :filter-method="filterJob">
                <el-option v-for="item in jobList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>

            <!-- 工作经验 -->
            <el-select v-model="searchForm.exp" placeholder="经验" clearable size="small">
                <el-option label="应届生" value="intern"></el-option>
                <el-option label="1-3年" value="1-3"></el-option>
                <el-option label="3-5年" value="3-5"></el-option>
                <el-option label="5年以上" value="5+"></el-option>
            </el-select>

            <!-- 公司规模 -->
            <el-select v-model="searchForm.scale" placeholder="公司规模" clearable size="small">
                <el-option label="0-50人" value="0-50"></el-option>
                <el-option label="50-200人" value="50-200"></el-option>
                <el-option label="200-1000人" value="200-1000"></el-option>
                <el-option label="1000人以上" value="1000+"></el-option>
            </el-select>

            <!-- 行业下拉 -->
            <el-select v-model="searchForm.industry" placeholder="行业" clearable size="small">
                <el-option label="互联网" value="internet"></el-option>
                <el-option label="金融" value="finance"></el-option>
                <el-option label="制造业" value="factory"></el-option>
            </el-select>

            <!-- 操作按钮 -->
            <el-button type="primary" size="small" @click="search">筛选</el-button>
            <el-button size="small" @click="reset">清空筛选</el-button>
        </div>

        <el-pagination layout="prev, pager, next" :page-size="20" :current-page="page" @current-change="pageChange"
            :hide-on-single-page="true" :total="totals">
        </el-pagination>

    </div>
    </div>
</template>

<script>
    import banner from "@/components/banner.vue"
    export default {
        components: {
            banner
        },
        data() {
            return {
                searchForm: {
                    city: "",
                    education: "",
                    salary: "",
                    job: "",
                    exp: "",
                    scale: "",
                    industry: ""
                },
                // 全部岗位原始数据
                allJob: [{
                        id: 1,
                        name: "前端开发"
                    },
                    {
                        id: 2,
                        name: "后端开发"
                    },
                    {
                        id: 3,
                        name: "产品经理"
                    },
                    {
                        id: 4,
                        name: "UI设计"
                    },
                    {
                        id: 5,
                        name: "测试工程师"
                    }
                ],
                // 下拉渲染岗位列表
                jobList: []
            }
        },
        created() {
            this.getIndex()
        },
        methods: {
            // 岗位下拉本地搜索过滤
            filterJob(val) {
                if (!val) {
                    this.jobList = [...this.allJob]
                    return
                }
                this.jobList = this.allJob.filter(item => item.name.includes(val))
            },
            // 筛选查询
            search() {
                console.log("筛选参数", this.searchForm)
                // 此处调用接口传参查询列表
            },
            // 重置筛选条件
            reset() {
                this.searchForm = {
                    city: "",
                    education: "",
                    salary: "",
                    job: "",
                    exp: "",
                    scale: "",
                    industry: ""
                }
                this.jobList = [...this.allJob]
            },
            pageChange(e) {

            },
            toDetail(e) {
                let that = this
                this.$router.push({
                    path: '/liveDetail', // 写路由path
                    query: {
                        type: e.is_type,
                        id: e.id
                    }
                })
            },
            getIndex() {
                let that = this
                getLiveIndex().then((Res) => {
                    console.log(Res)
                    if (Res.code == 1) {
                        that.bannerList = Res.data.banner
                        that.list1 = Res.data.list1
                        that.list2 = Res.data.list2
                        that.list3 = Res.data.list3
                    }
                })
            }
        }
    }
</script>

<style scoped>
    /deep/ .el-select .el-input__inner {
      border: none !important;
      background: transparent !important;
      box-shadow: none !important;
      padding: 0 18px 0 4px;
      color: #409EFF;
    }
    /deep/ .el-select .el-input__inner:focus {
      border: none !important;
      box-shadow: none !important;
    }
    /deep/ .el-select:hover .el-input__inner {
      border-color: transparent !important;
    }
    /deep/ .el-select .el-input__suffix {
      color: #409EFF;
    }
</style>